import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var Svg = styled.svg.withConfig({
	displayName: "Arrow__Svg",
	componentId: "sc-je38q7-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Arrow = function Arrow(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 475.93 270.04", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M466.53,207.5H79.4l69.1-78a11.57,11.57,0,0,0-1.07-16.18L130.19,98.21A11.57,11.57,0,0,0,114,99.28L4.86,222.45a12.82,12.82,0,0,0,0,16L114,361.59a11.57,11.57,0,0,0,16.18,1.07l17.25-15.12a11.57,11.57,0,0,0,1.07-16.18l-69.1-78H466.53A11.57,11.57,0,0,0,478,241.9V219A11.57,11.57,0,0,0,466.53,207.5Z",
			transform: "translate(-2.07 -95.41)"
		})
	);
};

Arrow.defaultProps = {
	fill: "#000000",
	scale: 1
};

Arrow.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1 = styled.svg.withConfig({
	displayName: "Caret__Svg",
	componentId: "sc-1ysly48-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Caret = function Caret(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement("polygon", {
			fill: fill,
			points: "240.8,390.4 475.6,172.3 406.6,98 240.4,252.3 74.3,98 5.3,172.3 "
		})
	);
};

Caret.defaultProps = {
	fill: "#000000",
	scale: 1
};

Caret.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$2 = styled.svg.withConfig({
	displayName: "Checkmark__Svg",
	componentId: "sc-1uryhwk-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Checkmark = function Checkmark(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$2,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 225.24 191.68", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M379,175c3,3,4,5,1,9-1.56,2.08-106.15,130.35-123,151-1.47,1.8-4,2-7,0s-89.78-73.06-91.09-74.33c-3.34-3.24-2.91-4.67.09-8.67,8.11-10.81,21.58-28,23.42-30.27,2.73-3.35,4-3.71,7.13-.87,3.33,3,49.95,42.64,49.95,42.64s94.77-112.15,97.64-115.82S342,144,345.5,146.5,377,173,379,175Z",
			transform: "translate(-156.57 -144.75)"
		})
	);
};

Checkmark.defaultProps = {
	fill: "#000000",
	scale: 1
};

Checkmark.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$3 = styled.svg.withConfig({
	displayName: "Download__Svg",
	componentId: "sc-qutxdz-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Download = function Download(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$3,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1344 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h465l135 136q58 56 136 56t136-56l136-136h464q40 0 68 28t28 68zm-325-569q17 41-14 70l-448 448q-18 19-45 19t-45-19l-448-448q-31-29-14-70 17-39 59-39h256v-448q0-26 19-45t45-19h256q26 0 45 19t19 45v448h256q42 0 59 39z"
		})
	);
};

Download.defaultProps = {
	fill: "#000000",
	scale: 1
};

Download.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$4 = styled.svg.withConfig({
	displayName: "DownloadImage__Svg",
	componentId: "sc-5rq0lk-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var DownloadImage = function DownloadImage(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$4,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1194.3114 1764.921", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1408.91,794.0471H1275.4719l-82.5337,82.5337H1408.91a18.8038,18.8038,0,0,1,13.9958,6.1256,20.1917,20.1917,0,0,1,5.9093,14.5078v784.0709a20.1921,20.1921,0,0,1-5.9093,14.5079,18.8037,18.8037,0,0,1-13.9958,6.1255H413.6508a18.804,18.804,0,0,1-13.9958-6.1255,20.1925,20.1925,0,0,1-5.9093-14.5079V897.2142a20.1922,20.1922,0,0,1,5.9093-14.5078,18.8041,18.8041,0,0,1,13.9958-6.1256H629.6229l-82.5337-82.5337H413.6508q-41.0544,0-70.29,30.3053t-29.2358,72.8618v784.0709q0,42.5565,29.2358,72.8618t70.29,30.3054h995.26q41.0544,0,70.29-30.3054t29.2359-72.8618V897.2142q0-42.5563-29.2359-72.8618T1408.91,794.0471Z",
			transform: "translate(-314.1249 -19.5312)"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M508.2005,995.2231q-34.834,36.1086-34.8341,87.6921t34.8341,87.6922q34.834,36.1084,84.597,36.1085t84.5971-36.1085q34.8341-36.1086,34.8341-87.6922t-34.8341-87.6921q-34.834-36.1085-84.5971-36.1085T508.2005,995.2231Z",
			transform: "translate(-314.1249 -19.5312)"
		}),
		React.createElement("polygon", {
			fill: fill,
			points: "159.242 1599.854 1035.07 1599.854 1035.07 1310.985 776.302 1042.751 457.819 1372.886 358.293 1269.718 159.242 1476.053 159.242 1599.854"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M1335.3548,480.4088q14.22,34.2939-11.71,58.5507L948.92,913.6839q-15.0559,15.8922-37.64,15.8923t-37.64-15.8923L498.9164,538.96q-25.9294-24.2568-11.71-58.5507,14.22-32.6211,49.35-32.6211H750.6844V73.0633q0-21.7474,15.8923-37.64t37.64-15.8924h214.1282q21.7475,0,37.64,15.8924t15.8923,37.64V447.7877H1286.005Q1321.1353,447.7877,1335.3548,480.4088Z",
			transform: "translate(-314.1249 -19.5312)"
		})
	);
};

DownloadImage.defaultProps = {
	fill: "#000000",
	scale: 1
};

DownloadImage.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$5 = styled.svg.withConfig({
	displayName: "InfoDot__Svg",
	componentId: "sc-dyj1nd-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Info = function Info(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$5,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M240.1,1.3c-132,0-239,107-239,239s107,239,239,239s239-107,239-239S372.1,1.3,240.1,1.3z M240.5,433.8C133.6,433.8,47,347.2,47,240.3S133.6,46.8,240.5,46.8S434,133.5,434,240.3S347.4,433.8,240.5,433.8z"
		}),
		React.createElement("circle", { fill: fill, cx: "240.3", cy: "140.3", r: "33.3" }),
		React.createElement("path", {
			fill: fill,
			d: "M309.2,353.9c0,10.3-8.5,18.8-18.8,18.8h-88.6c-10.3,0-18.8-8.5-18.8-18.8V334c0-10.3,8.5-18.8,18.8-18.8h16.5v-58.5h-6.1c-10.5,0-19.1-8.6-19.1-19.1v-19.3c0-10.5,8.6-19.1,19.1-19.1h42.8c8.7,0,16.1,6,18.4,14h0.7v5v19.3v77.5h16.3c10.3,0,18.8,8.5,18.8,18.8V353.9z"
		})
	);
};

Info.defaultProps = {
	fill: "#000000",
	scale: 1
};

Info.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$6 = styled.svg.withConfig({
	displayName: "LineChart__Svg",
	componentId: "sc-1bocxut-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var LineChart = function LineChart(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$6,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("polygon", {
			fill: fill,
			points: "1776.9,1447 1776.9,1557.1 15.7,1557.1 15.7,236.2 125.8,236.2 125.8,1447 "
		}),
		React.createElement("polygon", {
			fill: fill,
			points: "1106.8,994.9 1374,783.2 1538.5,1337 1666.8,1337 1446.7,566.4 1116.5,841.6 621.1,346.3 235.9,841.6 235.9,1020.6 627.7,516.8 "
		})
	);
};

LineChart.defaultProps = {
	fill: "#000000",
	scale: 1
};

LineChart.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$7 = styled.svg.withConfig({
	displayName: "Pencil__Svg",
	componentId: "sc-c3pohe-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Pencil = function Pencil(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$7,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement(
			"g",
			null,
			React.createElement(
				"g",
				null,
				React.createElement("path", {
					fill: fill,
					d: "M283.2,80.2C206.3,145.1,67.3,262.4,67.3,262.4l-0.7,2.6l68.1,11.6l0,0l0,0v65.2l57.3,9.8l0,0l0,0v60.5l1.5-0.1 c0,0,141.2-119.1,215.9-182.2L283.2,80.2z"
				})
			),
			React.createElement(
				"g",
				null,
				React.createElement("path", {
					fill: fill,
					d: "M432.3,210.4c16-13.5,26.8-22.6,29.1-24.6c12.4-10.5,17.3-21.7,3.2-38.2c-10.5-12.4-82.4-97.6-93.1-110.3 c-10.8-12.7-23.9-11.5-32.2-4.4c-1.7,1.4-14.4,12.1-33.3,28L432.3,210.4z"
				})
			),
			React.createElement(
				"g",
				null,
				React.createElement("path", {
					fill: fill,
					d: "M82.3,386c-13.5-16-27.9-25.8-40.3-31.9L22,428l81.2-7.7C98.8,409.3,92.1,397.6,82.3,386z"
				})
			)
		)
	);
};

Pencil.defaultProps = {
	fill: "#000000",
	scale: 1
};

Pencil.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$8 = styled.svg.withConfig({
	displayName: "Save__Svg",
	componentId: "sc-16npnxi-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Save = function Save(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$8,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M512 1536h768v-384h-768v384zm896 0h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zm-384-928v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zm640 32v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"
		})
	);
};

Save.defaultProps = {
	fill: "#000000",
	scale: 1
};

Save.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$9 = styled.svg.withConfig({
	displayName: "Search__Svg",
	componentId: "sc-1ko6l4r-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Search = function Search(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$9,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1216 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zm512 832q0 52-38 90t-90 38q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z"
		})
	);
};

Search.defaultProps = {
	fill: "#000000",
	scale: 1
};

Search.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$a = styled.svg.withConfig({
	displayName: "Star__Svg",
	componentId: "sc-1ubrx2a-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Star = function Star(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$a,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"
		})
	);
};

Star.defaultProps = {
	fill: "#000000",
	scale: 1
};

Star.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$b = styled.svg.withConfig({
	displayName: "X__Svg",
	componentId: "sc-4wncg8-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var X = function X(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$b,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 380 380", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M284,239.5,423,100.57a6.55,6.55,0,0,0,0-9.23L387.66,56a6.55,6.55,0,0,0-9.23,0L239.5,195,100.57,56a6.55,6.55,0,0,0-9.23,0L56,91.34a6.55,6.55,0,0,0,0,9.23L195,239.5,56,378.43a6.55,6.55,0,0,0,0,9.23L91.34,423a6.55,6.55,0,0,0,9.23,0L239.5,284,378.43,423a6.55,6.55,0,0,0,9.23,0L423,387.66a6.55,6.55,0,0,0,0-9.23Z",
			transform: "translate(-54.12 -54.12)"
		})
	);
};

X.defaultProps = {
	fill: "#000000",
	scale: 1
};

X.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

// import Aggregate from "./Aggregate.jsx";

export { Arrow, Caret, Checkmark, Download, DownloadImage, Info as InfoDot, LineChart, Pencil, Save, Search, Star, X };
//# sourceMappingURL=index.es.js.map
